import { tenantEmailDomainDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const EMAIL_DOMAINS_PATH = `${WEB_API_PREFIX}/tenant/email-domains`;
const domainSchema = dataEnvelopeSchema(tenantEmailDomainDTOSchema);
const domainListSchema = dataEnvelopeSchema(z.array(tenantEmailDomainDTOSchema));
export function createTenantEmailDomainsResource(transport) {
    return {
        async list() {
            const envelope = await transport.request({
                path: EMAIL_DOMAINS_PATH,
                schema: domainListSchema,
            });
            return envelope.data;
        },
        async add(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: EMAIL_DOMAINS_PATH,
                schema: domainSchema,
                body: input,
            });
            return envelope.data;
        },
        async remove(id) {
            await transport.request({
                method: 'DELETE',
                path: `${EMAIL_DOMAINS_PATH}/${encodeURIComponent(id)}`,
                schema: z.undefined(),
            });
        },
    };
}
//# sourceMappingURL=tenant-email-domains.js.map